import React from 'react';
export function SummaryBox({
  points
}: {
  points: string[];
}) {
  return <aside aria-labelledby="in-short-heading" className="rounded-[14px] bg-brand-soft px-6 py-6 sm:px-7" data-id="element-753" data-mp="lrcvgycex3rm">
      <h2 id="in-short-heading" className="text-[18px] font-semibold tracking-[-0.02em] text-ink" data-id="element-754" data-mp="72qfcueyo7zc">
        In short
      </h2>
      <ul className="mt-4 space-y-2.5" data-id="element-755" data-mp="c2l7106k91lg">
        {points.map(point => <li key={point} className="flex gap-3 text-[15.5px] leading-[1.6] text-ink-soft" data-id="element-756" data-mp="zrdxwi8bsj97">
            <span className="mt-[10px] h-1.5 w-1.5 shrink-0 rounded-full bg-brand" aria-hidden="true" data-id="element-757" data-mp="14pywyebucww2" />
            {point}
          </li>)}
      </ul>
      <p className="mt-5 border-t border-brand/15 pt-4 text-[13px] leading-[1.5] text-ink-muted" data-id="element-758" data-mp="qq68yqrp8urs">
        This summary is for convenience. The full text below applies.
      </p>
    </aside>;
}